<div class="min-w-168">
  <div class="w-full">
    <p class="text-lg uppercase tracking-widest text-white">Major Shareholders</p>
  </div>
  <div>
    <app-template-chart
      class="full-width tile-component text-center"
      [baseyear]="data.data.baseyear"
      [companyData]="data.data.companyNumbers"
      [config]="config"
      [noSliders]="true"></app-template-chart>
  </div>
</div>
